<template>
  <v-app-bar
    :height="barHeight"
    :extension-height="extensionHeight"
    clipped-left
    app
    color="white"
    :collapse="!collapseOnScroll"
    elevate-on-scroll
  >
    <!-- сетка шапки: боковые колонки 1fr равные (баннер центрируется по
         странице, колонки не ужимаются ниже своего контента), средняя —
         до 1200px (баннер 1100 + отступы по 50px), на меньших экранах
         ужимается первой -->
    <div
      style="
        display: grid;
        grid-template-columns: 1fr minmax(0, 1200px) 1fr;
        align-items: center;
        width: 100%;
      "
    >
    <!-- левая зона: бургер + лого -->
    <div class="d-flex align-center">
      <v-app-bar-nav-icon @click="changeDrawer(!navDrawer)" />

      <!-- <v-checkbox v-model="collapseOnScroll" hide-details></v-checkbox> -->
      <v-toolbar-title class="flex-shrink-0" style="overflow: visible">
        <span class="hidden-sm-and-down text-h5">
          <v-img
            contain
            width="140"
            src="../../../public/logo.png"
          ></v-img>
          <!-- <code>Nurken</code> -->
        </span>
      </v-toolbar-title>
    </div>

    <!-- баннер: середина сетки, отступы по 50px с боков -->
    <div
      v-if="!isMobileBanner"
      class="d-flex justify-center align-center"
      style="min-width: 0; padding: 0 50px"
    >
      <AdTemplate
        :adLocation="1"
        :width="bannerWidth"
        :box-height="bannerBoxHeight"
        fill
        class="ma-0"
        style="width: 100%; max-width: 100%; min-width: 0"
      ></AdTemplate>
    </div>
    <div v-else></div>

    <!-- правая зона: кнопки, баннер на них наехать не может -->
    <div
      class="d-flex align-center justify-end"
    >
    <UserDialog />
    <BankCardsDialog />

    <!-- <div class="ma-3">
      <v-icon color="primary">mdi-bell</v-icon>
    </div> -->
    <Language/>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <div class="ma-3">
          <v-btn text v-on="on">
            <v-icon color="primary" left>mdi-account</v-icon>
            <span class="text-capitalize primary--text font-weight-bold">{{
              user.login
            }}</span>
          </v-btn>
        </div>
      </template>
      <v-list>
        <v-list-item two-line>
          <v-list-item-avatar>
            <img
              src="https://img2.pngio.com/profile-male-persona-profile-male-user-avatar-svg-png-icon-free-user-avatar-png-981_878.png"
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ user.login }}</v-list-item-title>
            <v-list-item-subtitle
              >{{ user.firstName }} {{ user.lastName }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item-group>
          <v-list-item v-for="(item, i) in items" :key="i" @click="item.click">
            <v-list-item-icon>
              <v-icon color="primary" v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    </div>
    </div>

    <template v-slot:extension v-if="topBannerActive && isMobileBanner">
      <div
        class="d-flex justify-center align-center"
        style="flex: 1 1 auto; min-width: 0"
      >
        <AdTemplate
          :adLocation="1"
          :width="bannerWidth"
          :box-height="bannerBoxHeight"
          fill
          class="flex-grow-0 ma-0"
          style="max-width: 100%; min-width: 0"
        ></AdTemplate>
      </div>
    </template>
  </v-app-bar>
</template>
<script>
import Language from './Language.vue';
export default {
    name: "Toolbar",
    data() {
        return {
            collapseOnScroll: true,
            items: [
                {
                    text: "Профиль",
                    icon: "mdi-account",
                    click: () => {
                        this.$store.commit("SET_USER_DIALOG", true);
                    },
                },
                // {
                //   text: "Банковские карты",
                //   icon: "mdi-credit-card-multiple-outline",
                //   click: () => {
                //     this.$store
                //       .dispatch("HALYK_CARDS_CONTEXT")
                //       .then(() => {
                //         this.$store.commit("SET_HALYK_CARDS_DIALOG", true);
                //       })
                //       .catch((error) => {
                //         window.console.log(error);
                //       });
                //   },
                // },
                // {
                //   text: "Настройки",
                //   icon: "mdi-database-settings",
                //   click: () => {},
                // },
                {
                    text: "Выход",
                    icon: "mdi-account-remove-outline",
                    click: () => {
                        this.$store
                            .dispatch("CLEAR_TOKENS")
                            .then(() => { })
                            .catch((error) => {
                            window.console.log(error);
                        });
                        this.$store.commit("CLEAR_EXP_NOTICE");
                    },
                },
            ],
           
        };
    },
    methods: {
        changeDrawer(val) {
            this.$store.state.navDrawer = val;
        },
        GetUserByContext() {
            this.$store
                .dispatch("USER")
                .then(() => { })
                .catch((error) => {
                window.console.log(error);
            });
        },
    },
    computed: {
        navDrawer() {
            return this.$store.state.navDrawer;
        },
        user() {
            return this.$store.getters.USER;
        },
        topBannerActive() {
            const ad = this.$store.getters.ADS?.find((x) => x.id == 1);
            return ad?.adItems?.length > 0;
        },
        isMobileBanner() {
            // только вертикальные телефоны (<600px): баннер отдельной строкой под кнопками;
            // планшеты и телефоны в альбомной ориентации — в одну строку
            return this.$vuetify.breakpoint.xsOnly;
        },
        bannerWidth() {
            // целевой размер баннера 1100×120 (Full HD): на больших экранах
            // не растёт — стоит по центру (сетка 1fr|1200|1fr в шапке),
            // на меньших ужимается вместе со средней колонкой (отступы
            // по 50px с боков сохраняются). Стрелки — часть окна карусели,
            // всегда на краях баннера.
            // На мобильном — во всю ширину с отступами, но не шире 480
            if (this.isMobileBanner) {
                return "min(calc(100vw - 40px), 480px)";
            }
            return "min(100%, 1100px)";
        },
        bannerBoxHeight() {
            // константная высота бокса по брейкпоинту: все слайды карусели
            // рендерятся внутри, высота шапки не прыгает при смене креатива.
            // lg и выше (ноутбук/Full HD/больше) — 120 по требованию заказчика
            // (110 + 9%)
            const bp = this.$vuetify.breakpoint;
            if (bp.xsOnly) return 82;
            if (bp.smOnly || bp.mdOnly) return 98;
            return 120;
        },
        barHeight() {
            if (!this.topBannerActive || this.isMobileBanner) return 75;
            // +4px — необходимый минимум по макету: шапка ≈ 90–100px
            return Math.max(75, this.bannerBoxHeight + 4);
        },
        extensionHeight() {
            return Math.max(56, this.bannerBoxHeight + 4);
        }
    },
    created() {
        this.GetUserByContext();
    },
    components: {
      Language
    }
};
</script>
